/** Settlement destination dropdown (AU, Oct 2026): CaPay house account · Ebury · the customer's own settlement sub account.
 *  `options` come from GET /capay/customers/settlement-options (or embedded in a prefill). */
import { Landmark, Plus } from "lucide-react";

export const settlementOptionLabel = (o) =>
  o.key === "settlement_account" && !o.available
    ? "Create settlement account"
    : `${o.label} — ${o.account_name} · BSB ${o.bsb} · ${o.account_number}`;

export default function SettlementAccountSelect({ options = [], value, onChange, createHref, onCreate, reference, className = "", testId = "settlement-choice" }) {
  const selected = options.find((o) => o.key === value) || null;
  const wantsCreate = selected?.key === "settlement_account" && !selected.available;
  return (
    <div className={className} data-testid={`${testId}-wrap`}>
      <select value={value || ""} onChange={(e) => onChange?.(e.target.value)} className="h-9 w-full rounded-md border text-sm px-2 bg-white" data-testid={testId}>
        {options.map((o) => <option key={o.key} value={o.key} data-testid={`${testId}-opt-${o.key}`}>{settlementOptionLabel(o)}</option>)}
      </select>
      {selected && !wantsCreate && (
        <div className="mt-2 rounded-md border border-emerald-200 bg-emerald-50/60 px-3 py-2 text-xs grid grid-cols-2 sm:grid-cols-4 gap-2" data-testid={`${testId}-details`}>
          <div><p className="text-muted-foreground">Account name</p><p className="font-medium" data-testid={`${testId}-account-name`}>{selected.account_name}</p></div>
          <div><p className="text-muted-foreground">BSB</p><p className="font-mono font-medium" data-testid={`${testId}-bsb`}>{selected.bsb}</p></div>
          <div><p className="text-muted-foreground">Account number</p><p className="font-mono font-medium" data-testid={`${testId}-account-number`}>{selected.account_number}</p></div>
          <div><p className="text-muted-foreground">{selected.payid ? "PayID" : reference ? "Reference" : "Bank"}</p><p className="font-medium">{selected.payid || reference || selected.bank_name || "—"}</p></div>
        </div>
      )}
      {wantsCreate && (
        <div className="mt-2 rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-900 flex items-center gap-2 flex-wrap" data-testid={`${testId}-create-note`}>
          <Landmark className="w-3.5 h-3.5 shrink-0" />
          <span className="flex-1">No settlement sub account exists for this customer yet — payments can settle into CaPay, or create one.</span>
          {onCreate ? (
            <button type="button" onClick={onCreate} className="inline-flex items-center gap-1 h-7 px-2 rounded border border-amber-300 bg-white hover:bg-amber-100 font-medium" data-testid={`${testId}-create-btn`}><Plus className="w-3 h-3" /> Create settlement account</button>
          ) : createHref ? (
            <a href={createHref} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 h-7 px-2 rounded border border-amber-300 bg-white hover:bg-amber-100 font-medium" data-testid={`${testId}-create-link`}><Plus className="w-3 h-3" /> Create in Settlement A/C tab</a>
          ) : null}
        </div>
      )}
    </div>
  );
}
